import { API_CACHE_TTL } from '@/config';

export function getCached(cache: Map<string, any> | null, key: string) {
  if (!cache) {
    return null;
  }

  const entry = cache.get(key);

  if (!entry) {
    return null;
  }

  if (Date.now() - entry.timestamp > API_CACHE_TTL) {
    cache.delete(key);
    return null;
  }

  return entry.data as unknown;
}

export function setCached(
  cache: Map<string, any> | null,
  key: string,
  data: unknown
) {
  if (!cache) {
    return;
  }

  cache.set(key, { data, timestamp: Date.now() });
}

export function invalidateCache(cache: Map<string, any> | null, url?: string) {
  if (!cache) {
    return;
  }

  if (!url) {
    cache.clear();
  } else {
    cache.delete(url);
  }
}
